import * as CreateProjectInterestedTypes from 'src/actions/project/interested/create/Types';
import { CreateProjectInterestedAction } 
  from 'src/actions/project/interested/create/CreateProjectInterested.actions';

export interface CreateProjectInterestedState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: CreateProjectInterestedState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function CreateProjectInterestedReducer(state: CreateProjectInterestedState = initialState,
                                               action: CreateProjectInterestedAction): CreateProjectInterestedState {
  switch (action.type) {
    case CreateProjectInterestedTypes.CREATE_PROJECT_INTERESTED_ATTEMPT:
      return {...state, loading: true, error: false};
    case CreateProjectInterestedTypes.CREATE_PROJECT_INTERESTED_SUCCESS:
      return {...state, loading: false, error: false};
    case CreateProjectInterestedTypes.CREATE_PROJECT_INTERESTED_FAILURE:
      return {...state, loading: false, error: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project/interested/CreateProjectInterestedReducer.tsx